import { Button } from '@mui/material';


/**
 * AtplPrimaryBt component
 * This component renders a primary button with customizable behavior and styling.
 * It accepts three props: a click handler, a title for the button, and custom styles.
 *
 * @param {Object} props - The props for the button component.
 * @param {Function} props.onclick - The click handler function to be executed when the button is clicked.
 * @param {string} props.btnTitle - The title or text to display inside the button.
 * @param {Object} [props.sx] - Optional custom styles to apply to the button (e.g., passed from a style system like `sx` from Theme UI or MUI).
 *
 * @returns {JSX.Element} A button element with the provided title, onClick behavior, and optional styles.
 */

const AtplPrimaryBt = ({onclick,btnTitle,sx}) => {

      // Handle button click by executing the provided `onclick` function.
    const handleClick = () => {
        onclick();
    }
    return (
        <Button type="button" className="atpl-basic-btn"
        sx={{
            minWidth : {xs : '120px ',sm : '150px',md :'175px' ,lg : '175px'},
            paddingX: '20px',
            height: {xs : '46px',sm : '48px',md :'60px' ,lg : '60px'},
            borderRadius: "10px",
            backgroundColor: "#F15C30",
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
            fontSize:{xs : '16px',sm : '18px',md :'20px' ,lg : '20px'},
            fontWeight: "600",
            lineHeight: "30px",
            textAlign: "center",
            color: "#FFFFFF",
            marginTop: {xs : '30px',sm : '30px',md :'54px' ,lg : '54px'},
            '&:hover': {
                backgroundColor: "#E94E1B",

            },
            ...sx, // Merge custom styles here
        }}
            onClick={handleClick} >
            {btnTitle}
        </Button>
    )
}

export default AtplPrimaryBt